import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";

function write_t$prime(write__int32_genarray, write__int64_genarray, write__float32_genarray, write__float64_genarray) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    var variant = x[0];

    if (variant >= 28091885) {
      if (variant >= 81581934) {
        return Atdgen_codec_runtime.Encode.constr1("Float64_genarray", write__float64_genarray, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("Float32_genarray", write__float32_genarray, x[1]);
      }
    } else if (variant >= -661245189) {
      return Atdgen_codec_runtime.Encode.constr1("Int64_genarray", write__int64_genarray, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Int32_genarray", write__int32_genarray, x[1]);
    }
  });
}

function read_t$prime(read__int32_genarray, read__int64_genarray, read__float32_genarray, read__float64_genarray) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Float32_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Float32_genarray */
        [28091885, x]
      );
    }, read__float32_genarray, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Float64_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Float64_genarray */
        [81581934, x]
      );
    }, read__float64_genarray, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Int32_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Int32_genarray */
        [-714735238, x]
      );
    }, read__int32_genarray, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Int64_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Int64_genarray */
        [-661245189, x]
      );
    }, read__int64_genarray, param);
  }]],
  /* [] */
  0]]]]);
}

function write_ints$prime(write__int32_genarray, write__int64_genarray) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    if (x[0] >= -661245189) {
      return Atdgen_codec_runtime.Encode.constr1("Int64_genarray", write__int64_genarray, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Int32_genarray", write__int32_genarray, x[1]);
    }
  });
}

function read_ints$prime(read__int32_genarray, read__int64_genarray) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Int32_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Int32_genarray */
        [-714735238, x]
      );
    }, read__int32_genarray, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Int64_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Int64_genarray */
        [-661245189, x]
      );
    }, read__int64_genarray, param);
  }]],
  /* [] */
  0]]);
}

function write_floats$prime(write__float32_genarray, write__float64_genarray) {
  return Atdgen_codec_runtime.Encode.make(function (x) {
    if (x[0] >= 81581934) {
      return Atdgen_codec_runtime.Encode.constr1("Float64_genarray", write__float64_genarray, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Float32_genarray", write__float32_genarray, x[1]);
    }
  });
}

function read_floats$prime(read__float32_genarray, read__float64_genarray) {
  return Atdgen_codec_runtime.Decode.$$enum(
  /* :: */
  [
  /* tuple */
  ["Float32_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Float32_genarray */
        [28091885, x]
      );
    }, read__float32_genarray, param);
  }]],
  /* :: */
  [
  /* tuple */
  ["Float64_genarray",
  /* `Decode */
  [427938126, function (param) {
    return Atdgen_codec_runtime.Decode.map(function (x) {
      return (
        /* `Float64_genarray */
        [81581934, x]
      );
    }, read__float64_genarray, param);
  }]],
  /* [] */
  0]]);
}

export { read_t$prime, write_t$prime, read_ints$prime, write_ints$prime, read_floats$prime, write_floats$prime };
/* No side effect */